<template>
  <div>
    <div class="wrapper">
      <!--      <album-call-to-action></album-call-to-action>-->
      <div id="player-wrapper">
        <div id="player" class="w-container">
          <div class="w-row">
            <div class="w-col w-col-2" id="playing">
              <div class="w-row">
                <div
                  class="w-col w-col-12 w-col-small-6 w-col-tiny-6"
                  v-if="song !== null"
                  id="artist"
                >
                  <strong>{{ song.artist }}</strong>
                </div>
                <div
                  class="w-col w-col-12 w-col-small-6 w-col-tiny-6"
                  v-if="song !== null"
                  id="song"
                >
                  {{ song.song }}
                </div>
                <div class="col" v-if="song === null">Loading{{ loading }}</div>
              </div>
            </div>
            <div class="w-col w-col-1 w-hidden-medium"></div>
            <div class="w-col w-col-7">
              <Controller
                :song="song"
                :show="show"
                :index="index"
                :length="length"
                v-on:toggle-playlist="togglePlaylist"
                v-on:next-song="nextSong"
                v-on:prev-song="prevSong"
              />
            </div>
            <div id="arrow" class="w-hidden-small w-hidden-tiny">
              <img :src="download_arrow" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="slide">
      <Playlist
        v-if="show"
        v-on:select-song="selectSong"
        :playlist="playlist"
        class="playlist"
      />
    </transition>
  </div>
</template>

<script>
import Playlist from "./Playlist.vue";
import Controller from "./Controller.vue";

export default {
  data() {
    return {
      playlist: [],
      download_arrow: require("../../../assets/images/download-arrow.svg"),
      show: false,
      song: null,
      dots: 3,
      loading: "...",
      index: 0,
      length: 0,
    };
  },
  methods: {
    togglePlaylist: function () {
      this.show = !this.show;
    },
    selectSong: function (song) {
      this.song = song;
      for (var i = 0; i < this.length; i++) {
        if (song === this.playlist[i]) {
          this.index = i + 1;
          break;
        }
      }
    },
    loadingAnimation: function () {
      if (this.song === null) {
        this.loading = "";
        for (var i = 0; i < this.dots; i++) {
          this.loading += ".";
        }
        this.dots += 1;
        this.dots %= 4;
      }
      setTimeout(this.loadingAnimation, 500);
    },
    handlePlaylistLoad: function (response) {
      this.playlist = response.data;
      this.length = this.playlist.length;
      if (this.playlist.length > 0) {
        this.selectSong(this.playlist[0]);
      }
    },
    nextSong: function () {
      if (this.index < this.length) {
        this.selectSong(this.playlist[this.index]);
      }
    },
    prevSong: function () {
      if (this.index > 1) {
        this.selectSong(this.playlist[this.index - 2]);
      }
    },
  },
  components: {
    Playlist,
    Controller,
  },
  mounted() {
    this.$http
      .get("audio-file/")
      .then((response) => this.handlePlaylistLoad(response));
    this.loadingAnimation();
  },
  name: "MusicPlayer",
};
</script>

<style scoped lang="scss">
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.wrapper {
  position: absolute;
  bottom: 0;
  width: 100%;
}

#player {
  position: relative;
  width: 1140px;
}

#player-wrapper {
  background-color: hsla(0, 0%, 100%, 0.94);
  position: relative;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  /*overflow: hidden;*/
}

#artist {
  font-weight: bold;
}

#artist,
#song {
  color: #3a5060;
}

#playing {
  border-right: 2px solid #3a5060;
  height: 100%;
}

@media (max-width: 767px) {
  #playing {
    border-right: none;
    margin-bottom: 3px;
  }

  #wrapper {
    padding: 5px;
  }
}

#arrow {
  background: white no-repeat center;
  border: 1px solid #dcdcdc;
  border-bottom: none;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  position: absolute;
  right: 0;
  width: 6.66666%;
  height: calc(130% + 40px);
  top: calc(-20px - 30%);
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

@media (max-width: 991px) {
  #arrow {
    width: 12.222222%;
  }
}

#arrow img {
  width: 50%;
  -webkit-animation-name: arrow-slide;
  -moz-animation-name: arrow-slide;
  -o-animation-name: arrow-slide;
  animation-name: arrow-slide;
  -webkit-animation-duration: 2s;
  -moz-animation-duration: 2s;
  -o-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -o-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  -webkit-animation-direction: alternate;
  -moz-animation-direction: alternate;
  -o-animation-direction: alternate;
  animation-direction: alternate;
}

.playlist {
  display: block;
}

@keyframes arrow-slide {
  from {
    margin-top: -10px;
  }

  to {
    margin-top: 10px;
  }
}
</style>
